import { Stack, Theme, Typography } from "@mui/material";
import ExpandableText from "../../ExpandableText";
import { HISTORY_EVENT } from "../../../models/eventTypes";

interface EventContentProps {
  event: TranslationHistoryItem
  disabled?: boolean
}

const EventContent: React.FC<EventContentProps> = ({ event, disabled }) => {

  const renderTranslation = (value: string | null) => {
    if (!value) {
     return null;
    }

   return (
     <ExpandableText
       variant="caption"
       text={value ?? ''}
       color="text.secondary"
       sx={disabled ? styles.disabledTranslation : styles.translation}
     />
   );
  };

   const renderChangeReason = (reason: string) => (
    <Typography
      variant="caption"
      sx={disabled ? styles.disabledReason : styles.reason}
    >
      {'>'} {reason}
    </Typography>
  );

  if (event.eventType === HISTORY_EVENT.Initial || event.eventType === HISTORY_EVENT.InitialPublished) {
    return (
      <Stack spacing={0.4}>
        {renderTranslation(event.newValue)}
        {renderTranslation(event.oldValue)}
      </Stack>
    )
  }

  if (event.eventType === HISTORY_EVENT.Edit || event.eventType === HISTORY_EVENT.EditPublished || event.eventType === HISTORY_EVENT.Edited) {
    return (
      <Stack spacing={0.4}>
        {event.changeReason && renderChangeReason(event.changeReason)}
        {renderTranslation(event.newValue)}
      </Stack>
    )
  }

  return event.changeReason ? renderChangeReason(event.changeReason) : null;
};

const styles = {
  reason: {
    m: 0,
    fontSize: '14px',
    lineHeight: '1.1',
  },
  translation: {
    m: 0,
    fontSize: '14px',
    lineHeight: '1.1',
    fontStyle: 'italic',
  },
  disabledReason: {
    m: 0,
    fontSize: '14px',
    lineHeight: '1.1',
    color: (theme: Theme) => theme.palette.grey[400]
  },
  disabledTranslation: {
    m: 0,
    fontSize: '14px',
    lineHeight: '1.1',
    fontStyle: 'italic',
    color: (theme: Theme) => theme.palette.grey[400]
  }
} as const

export default EventContent;
